var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbbvieBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bin icon",
    d: "M0.714286 10.6667C0.714286 11.4 1.35714 12 2.14286 12H7.85714C8.64286 12 9.28571 11.4 9.28571 10.6667V2.66667H0.714286V10.6667ZM2.47143 5.92L3.47857 4.98L5 6.39333L6.51429 4.98L7.52143 5.92L6.00714 7.33333L7.52143 8.74667L6.51429 9.68667L5 8.27333L3.48571 9.68667L2.47857 8.74667L3.99286 7.33333L2.47143 5.92ZM7.5 0.666667L6.78571 0H3.21429L2.5 0.666667H0V2H10V0.666667H7.5Z",
    fill: "#071C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbvieBin);
export default __webpack_public_path__ + "static/media/abbvieBin.87e3abc76deee234087754646fdb0434.svg";
export { ForwardRef as ReactComponent };